import { mount } from "svelte";
import App from "./App.svelte";
import { startRouter } from "./lib/router.svelte.js";
import { loadPrefs, watchSystemTheme } from "./lib/prefs.svelte.js";
import { loadSession } from "./lib/session.svelte.js";

loadPrefs();
watchSystemTheme();
startRouter();
loadSession();

const app = mount(App, { target: document.getElementById("app") });

export default app;
